import React from "react";
import {
  CalendarToday,
  CalendarMonth,
  Person,
  AttachMoney,
  CreditCard,
  DirectionsCar,
  Edit,
  Close,
  Refresh,
  Check,
  Add,
  BarChart,
  Settings,
  Label,
  Build,
  ContentCut,
  Event,
  Schedule,
  Group,
  Receipt,
  Dashboard,
  Repeat,
  ContentCopy,
  Logout,
  ChevronLeft,
  ChevronRight,
  ArrowBack,
  Cake,
  Delete,
  Lock,
  Save,
  Warning,
  Visibility,
  VisibilityOff,
  Phone,
  History,
  Lightbulb,
  LinkOff,
  Assignment,
  Badge,
  TrendingDown,
  TrendingUp,
  ShoppingCart,
  Folder,
  DarkMode,
  LightMode,
} from "@mui/icons-material";
import { Company } from "../../types";

/** Service icon by company category (returns MUI icon element) */
export const getServiceIcon = (company: Company | null, size?: number): React.ReactNode => {
  const s = size ?? 20;
  if (!company) return <Build sx={{ fontSize: s }} />;
  switch (company.category) {
    case "barbershop":
      return <ContentCut sx={{ fontSize: s }} />;
    case "car":
      return <Build sx={{ fontSize: s }} />;
    default:
      return <Build sx={{ fontSize: s }} />;
  }
};

export const Icons = {
  Calendar: CalendarToday,
  CalendarMonth,
  Event,
  Person,
  Money: AttachMoney,
  Payment: CreditCard,
  Car: DirectionsCar,
  Edit,
  Close,
  Refresh,
  Check,
  Add,
  Chart: BarChart,
  Settings,
  Label,
  Build,
  ContentCut,
  Schedule,
  Group,
  Receipt,
  Dashboard,
  Repeat,
  ContentCopy,
  Logout,
  ChevronLeft,
  ChevronRight,
  ArrowBack,
  Cake,
  Delete,
  Lock,
  Save,
  Warning,
  Visibility,
  VisibilityOff,
  Phone,
  History,
  Lightbulb,
  LinkOff,
  Assignment,
  Badge,
  TrendingDown,
  TrendingUp,
  ShoppingCart,
  Folder,
  DarkMode,
  LightMode,
};

export default Icons;
